// extracted by mini-css-extract-plugin
module.exports = {"orange":"#fc8101","alabaster":"#fafafa","atlantis":"#87c925","fuel-yellow":"#e9b01c","silver-chalice":"#aaa","serenade":"#fff1e5"};